export const BUSINESS_OWNER_INFO = {
  busInfoFields: [
    {
      label: 'Account Number',
      name: 'business.accountNo',
      type: 'number',
    },
    {
      label: 'Business Name',
      name: 'business.businessName',
      type: 'text',
    },
    {
      label: 'Business Phone',
      name: 'business.businessPhone',
      type: 'tel',
    },
  ],
  busAddressFields: {
    street: 'business.busAddr.street',
    city: 'business.busAddr.city',
    state: 'business.busAddr.state',
    zip: 'business.busAddr.zip',
  },
  mailAddressFields: {
    street: 'business.mailAddr.street',
    city: 'business.mailAddr.city',
    state: 'business.mailAddr.state',
    zip: 'business.mailAddr.zip',
  },
  ownerInfoFields: [
    {
      label: 'Full Name',
      name: 'business.ownerName',
      type: 'text',
    },
    {
      label: 'Phone',
      name: 'business.ownerPhone',
      type: 'tel',
    },
    {
      label: 'Email',
      name: 'business.email',
      type: 'email',
    },
    {
      label: `Owner's statement of circumstances`,
      name: 'business.statement',
      multiline: true,
      placeholder: 'Enter statement here...',
      rows: 6,
      type: 'text',
      variant: 'outlined',
    },
  ],
};
